import React, { useCallback, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../commonDesign/Button'
import SydModalActions from '../../../../../../commonDesign/SydModal/SydModalActions'
import { useSetActiveQueryBlueprintVersion } from '../../../../../../../api/denali'
import { decipherError } from '../../../../../../../utils/decipherError'
import FieldDisplay from '../../../../../../molecules/FieldDisplay'

const useSubmitter = (onComplete, blueprint, version) => {
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: setActiveVersion } = useSetActiveQueryBlueprintVersion()

  const onSubmit = useCallback(async () => {
    const command = {
      blueprintId: blueprint.blueprintId,
      definitionVersionId: version.definitionVersionId
    }

    try {
      setError(null)
      setProcessing(true)

      const result = await setActiveVersion(command)
      if (result?.statusCode === 500) {
        throw new Error('Failed to set active version')
      }
      onComplete(result)
    } catch (err) {
      setError(decipherError(err))
    } finally {
      setProcessing(false)
    }
  }, [setActiveVersion, blueprint, version, onComplete])

  return {
    submitter: onSubmit,
    processing,
    error
  }
}

function SetActiveVersionForm ({ blueprint, version, onCancel, onComplete }) {
  const { submitter, processing, error } = useSubmitter(onComplete, blueprint, version)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h3>Current Active Version</h3>
        <FieldDisplay
          fields={[
            { label: 'Version ID', value: blueprint.definitionVersionId || 'None' }
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <h3>New Active Version</h3>
        <FieldDisplay
          fields={[
            { label: 'Version ID', value: version.definitionVersionId },
            { label: 'Description', value: version.description || '-' },
            { label: 'Created', value: version.versionDate ? new Date(version.versionDate).toLocaleDateString() : '-' }
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <p>Are you sure you want to set this version as the active version?</p>
        <p style={{ fontSize: '0.875rem', color: '#666' }}>
          The blueprint will use this definition when executed.
        </p>
      </Grid>

      <Grid item xs={12}>
        <SydModalActions>
          {error ? <div className='__error'>{error}</div> : null}
          <SydButton disabled={processing} variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton
            processing={processing}
            variant='primary'
            size='md'
            onClick={submitter}
          >
            Set as Active
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

SetActiveVersionForm.propTypes = {
  blueprint: PropTypes.object.isRequired,
  version: PropTypes.object.isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default SetActiveVersionForm
